import { createContext, useContext, useState, useEffect, useRef, useCallback } from 'react';
import { LANG } from './data/translations.js';

const AppCtx = createContext(null);

export function AppProvider({ children }) {
  const [lang, setLang] = useState(() => {
    // Приоритет: ?lang= в URL (для hreflang deep-link'ов и расшаривания) >
    //           сохранённый выбор > ru по умолчанию.
    if (typeof window !== 'undefined') {
      const urlLang = new URLSearchParams(window.location.search).get('lang');
      if (urlLang === 'en' || urlLang === 'ru') return urlLang;
    }
    return localStorage.getItem('lf-lang') || 'ru';
  });
  const [cursorMode, setCursorMode] = useState('default');
  const [toast, setToast] = useState('');

  useEffect(() => {
    document.documentElement.lang = lang;
    localStorage.setItem('lf-lang', lang);
  }, [lang]);

  const t = LANG[lang];
  const li = lang === 'ru' ? 0 : 1;

  const showToast = useCallback((text) => {
    setToast(text);
    setTimeout(() => setToast(''), 2000);
  }, []);

  const copy = useCallback((text) => {
    navigator.clipboard?.writeText(text).then(() =>
      showToast(lang === 'ru' ? 'Скопировано!' : 'Copied!')
    );
  }, [lang, showToast]);

  const CH = useCallback(() => setCursorMode('hover'), []);
  const CL = useCallback(() => setCursorMode('default'), []);
  const CV = useCallback(() => setCursorMode('view'), []);

  return (
    <AppCtx.Provider value={{
      lang, setLang, t, li,
      cursorMode, setCursorMode, CH, CL, CV,
      toast, showToast, copy,
    }}>
      {children}
    </AppCtx.Provider>
  );
}

export function useApp() {
  const v = useContext(AppCtx);
  if (!v) throw new Error('useApp must be used inside AppProvider');
  return v;
}
